export default "__VITE_ASSET__C80UI$tI__"